import GeoJSON from 'ol/format/GeoJSON'
import axios from 'axios'

export const setupMarkers = geoJsonData => {
  return (new GeoJSON({
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:3857'
  })).readFeatures(geoJsonData)
}

export const isCluster = feature => {
  if (!feature || !feature.get('features')) {
    return false
  }
  return feature.get('features').length > 1
}

export const getFeature = feature => {
  // console.log(isCluster(feature))
  // console.log(feature)
  return isCluster(feature) ? feature : feature.get('features')[0]
}

export const getTypesForLayers = () => {
  return axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
    request: 'GetCapabilities',
    outputFormat: 'application/json'
  })
    .then(response => response.data)
    .then(text => {
      const domParser = new DOMParser()
      const xmlDoc = domParser.parseFromString(text, 'text/xml')
      return _(xmlToJson(
        xmlDoc)['wfs:WFS_Capabilities'].FeatureTypeList.FeatureType).map(
        f => (_.includes(f.Name['#text'], 'view_kulturarv_stadsdelar_') ||
              _.includes(f.Name['#text'], 'view_kulturarv_omraden_') ||
              _.includes(f.Name['#text'], 'view_kulturarv_byggnader_'))
          ? _.replace(f.Name['#text'], 'kulturarv:', '')
          : null
        //   f => (_.includes(f.Name['#text'], 'view_kulturarv_omraden_') ||
        //       _.includes(f.Name['#text'], 'view_kulturarv_byggnader_'))
        //   ? _.replace(f.Name['#text'], 'kulturarv:', '')
        //   : null
      ).compact().value()
    })
}

function xmlToJson (xml) {
  // Create the return object
  let obj = {}

  if (xml.nodeType === 1) { // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj['@attributes'] = {}
      for (let j = 0; j < xml.attributes.length; j++) {
        const attribute = xml.attributes.item(j)
        obj['@attributes'][attribute.nodeName] = attribute.nodeValue
      }
    }
  } else if (xml.nodeType === 3) { // text
    obj = xml.nodeValue
  }

  // do children
  if (xml.hasChildNodes()) {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i)
      const nodeName = item.nodeName
      if (typeof (obj[nodeName]) === 'undefined') {
        obj[nodeName] = xmlToJson(item)
      } else {
        if (typeof (obj[nodeName].push) === 'undefined') {
          const old = obj[nodeName]
          obj[nodeName] = []
          obj[nodeName].push(old)
        }
        obj[nodeName].push(xmlToJson(item))
      }
    }
  }
  return obj
}
